import React, { useEffect } from "react";
import * as IoIcons from "react-icons/io5";
import AOS from "aos";
import "aos/dist/aos.css";
import "../../pages/Landing/Home.css";
import "../../data/data.json";
const img_1: string = require("../../assets/picme.jpg");
const cv: string = require("../../assets/dev-cv.pdf");

const About = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <>
      {" "}
      <div className="section_3 flex items-center pt-[40px] semi-md:pt-[80px]">
        <div className="about">
          <div className="image-part w-[40%]">
            <img src={img_1} alt="" className="w-[400px] object-cover" />
          </div>
          <div className="about-text">
            <div className="px-10 sm:px-5">
              <h1
                className="underline text-[25px] font-bold"
                data-aos="fade-up"
              >
                ABOUT <span className="text-[#0093df] text-[30px] ">ME</span>
              </h1>
              <p data-aos="fade-up">
                ✋Hi again; I am{" "}
                <span className="font-semibold text-[#0093df]">
                  Rutayisire Gerard
                </span>{" "}
                from Kigali, Rwanda. I'm a University Of Rwanda student and a
                former{" "}
                <span className="font-semibold text-[#0093df]">
                  Andela Technical Leadership Program
                </span>{" "}
                trainee in software development with skills in various
                programming languages that I can apply to build frontend graphic
                designs and build apps with backend technologies.
              </p>
              <div className="image-part-1 mt-5" data-aos="fade-up">
                <img src={img_1} alt="" className="w-[400px] object-cover" />
              </div>
              <br />
              <p data-aos="fade-up">
                I enjoy working in teams in most of my projects because this
                always helps with gaining skills from teammates and helping each
                other, and also making friends and more connections. Teams also
                give a lesson of flexibility for understanding each other and
                being open for suggestions.
              </p>
              <br />
              <p data-aos="fade-up">
                I'm open to Job opportunities where I can contribute, learn and
                grow. If you have a good opportunity that matches my skills and
                experience then don't hesitate to contact me.
              </p>
              <div className="flex items-center w-fit mx-auto gap-2">
                <a href={cv} target="_blank">
                  <button data-aos="fade-up" className="flex items-center">
                    Download CV
                  </button>
                </a>
                <a href="mailto:rutayisiregerard2002@gmail.com" target="_blank">
                  <button
                    data-aos="fade-up"
                    className="flex items-center gap-1"
                  >
                    Hire me <IoIcons.IoPaperPlane />
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
